import * as React from "react";

function SvgPlanetSaturn(props) {
  return (
    <svg viewBox="0 0 305.3 288.1" {...props}>
      <defs>
        <radialGradient
          id="planet-saturn_svg__d"
          cx={-874.15}
          cy={507.05}
          r={110.11}
          gradientTransform="matrix(.03 -.88 .9 -.16 -351.06 -608.51)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#f4f4f4" />
          <stop offset={1} />
        </radialGradient>
        <radialGradient
          id="planet-saturn_svg__g"
          cx={-874.15}
          cy={507.05}
          r={110.11}
          gradientTransform="matrix(.03 -.88 .9 -.16 -351.06 -608.51)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#fff" />
          <stop offset={1} stopColor="#f3f9f7" />
        </radialGradient>
        <linearGradient
          id="planet-saturn_svg__e"
          x1={124.21}
          y1={115.08}
          x2={184.42}
          y2={176.41}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#c39783" />
          <stop offset={1} stopColor="#fff1e6" />
        </linearGradient>
        <linearGradient
          id="planet-saturn_svg__h"
          x1={124.21}
          y1={115.08}
          x2={184.42}
          y2={176.41}
          xlinkHref="#planet-saturn_svg__e"
        />
        <filter
          id="planet-saturn_svg__a"
          x={49.43}
          y={-8226.21}
          width={119.89}
          height={32766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <filter
          id="planet-saturn_svg__c"
          x={49.43}
          y={43.22}
          width={119.89}
          height={118.7}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <mask
          id="planet-saturn_svg__f"
          x={49.43}
          y={43.22}
          width={119.89}
          height={118.7}
          maskUnits="userSpaceOnUse"
        >
          <g
            mask="url(#planet-saturn_svg__b)"
            filter="url(#planet-saturn_svg__c)"
          >
            <path
              d="M72.84 64.52c25.41-24.42 66-29.17 87.33-7.3S162.1 98.83 137.8 129c-20 24.8-54.28 45.54-75.58 23.68S47.43 88.94 72.84 64.52z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#planet-saturn_svg__d)"
            />
          </g>
        </mask>
      </defs>
      <g data-name="Layer 2">
        <circle
          cx={141.77}
          cy={132.15}
          r={100.78}
          transform="rotate(-45 141.78 132.153)"
          fill="#cca750"
        />
        <path
          d="M65.77 66.14a83.23 83.23 0 11-5.34 6.7 100.91 100.91 0 105.34-6.7z"
          fill="#bd7a59"
          opacity={0.72}
        />
        <path
          d="M197 184.73c-32.43 34.69-82.81 41.89-123.24 21.73a101 101 0 00141.47-5.39c38.18-40.52 35.85-104.82-4.83-142.65-.45-.41-.62 0-1.07-.41 24.09 38.5 20.83 91.22-12.33 126.72z"
          fill="#995f41"
        />
        <path
          d="M170.57 35.58A99.67 99.67 0 00149 31.64c-1.22 3.79-2.21 6.76-2.53 7.52a176.78 176.78 0 01-15.4 28.37 180 180 0 01-45 45.94 301.38 301.38 0 01-44.8 26.43c0 .35 0 .71.07 1.06a100.19 100.19 0 002.91 16.69c52.46-22.06 106.46-66.17 126.32-122.07z"
          fill="#a3966d"
        />
        <path
          d="M139.9 31.42c-1.28.06-2.57.14-3.86.25s-2.58.28-3.86.44C110 69.43 78.82 102.37 41.85 124.62a104.11 104.11 0 00-.16 19c.07.62.13 1.25.21 1.86a151.62 151.62 0 0029.94-17.1c20.41-15 39.88-31.47 55.76-51.18a165.82 165.82 0 0026.31-45.1 101.55 101.55 0 00-14.01-.68z"
          fill="#9d9bae"
        />
        <path
          d="M56.48 185.82c61.34-27.17 111.73-77 141.57-137.25a100.59 100.59 0 00-11.5-6.71A277.3 277.3 0 0151.69 177.33c1.47 2.91 3.06 5.75 4.79 8.49z"
          fill="#e6ba5b"
        />
        <path
          d="M218.29 89.14a75.62 75.62 0 006.77-13.71 101.2 101.2 0 00-17.93-20c-11.65 26.43-28.14 50.68-47.45 72.21-22.33 24.89-48.38 46.25-75.95 65.17A118 118 0 0169 201.79a101.42 101.42 0 0014.15 12.28C137.53 184 186.41 142.41 218.29 89.14z"
          fill="#e1c364"
        />
        <path
          d="M186.55 41.86c-2.16 4.75-4.51 9.4-7 14l.31.23a83.77 83.77 0 019.42 8.78q4.6-8 8.72-16.3a100.59 100.59 0 00-11.45-6.71zM225.06 75.43a101.2 101.2 0 00-17.93-20q-4.44 10-9.77 19.67a82.6 82.6 0 0111.87 28.08c3.14-4.61 6.19-9.27 9.06-14.07a75.62 75.62 0 006.77-13.68z"
          fill="#d2aa57"
        />
        <path
          d="M133 31.76c-1.26.11-2.5.27-3.75.43-21.5 36.24-51.8 68.22-87.7 89.83a102.28 102.28 0 00-.17 18.98c0 .46.11.9.15 1.35a146.49 146.49 0 0029.1-16.62c19.82-14.55 38.72-30.6 54.14-49.73a160.93 160.93 0 0025.72-44.23 101.59 101.59 0 00-17.49-.01z"
          fill="#9484a8"
        />
        <path
          d="M133 31.76a100.79 100.79 0 00-33.8 9c-5.76 12.93-14.9 24.32-25.38 33.87a210.58 210.58 0 01-25.35 19.45 100.1 100.1 0 00-7.4 34.75 159.24 159.24 0 0019.24-11.08 235.2 235.2 0 0026.36-21.18 238.49 238.49 0 0042.47-52.4 135.63 135.63 0 006.74-12.59c-.97.06-1.94.1-2.88.18z"
          fill="#795887"
        />
        <path
          d="M47.43 96.66a176.35 176.35 0 0032.7-25.73 120.16 120.16 0 0022.6-31.7 101.09 101.09 0 00-55.3 57.43z"
          fill="#604c6a"
        />
        <path
          d="M133 31.76A100.8 100.8 0 0050.06 174c35.85 9.15 72.5-2.74 99.67-31.58 28.06-29.78 38.26-69.7 25-105.44A100.43 100.43 0 00133 31.76z"
          fill="#fff"
          opacity={0.15}
        />
        <g mask="url(#planet-saturn_svg__f)">
          <path
            d="M72.84 64.52c25.41-24.42 66-29.17 87.33-7.3S162.1 98.83 137.8 129c-20 24.8-54.28 45.54-75.58 23.68S47.43 88.94 72.84 64.52z"
            opacity={0.39}
            fill="url(#planet-saturn_svg__g)"
          />
        </g>
        <path
          d="M242.16 123.34A100.78 100.78 0 00133 31.76a102.58 102.58 0 00-16.12 2.75 99.64 99.64 0 01109.5 144.16 100.61 100.61 0 01-120.69 47.58 100.81 100.81 0 00136.47-102.91z"
          style={{
            mixBlendMode: "screen",
          }}
          fill="#fff"
          opacity={0.31}
        />
        <path
          d="M302.39 3.51C291.22-8.39 250 10.77 198.64 49a101.41 101.41 0 018.51 6.52c29.68-19.66 53.94-29.64 62.14-20.9 8.89 9.47-5.37 36.4-30.46 68-.17.2-.35.41-.51.62-17 21.31-38.83 44.7-61.81 66.26s-47.42 41.66-69.66 57.22l-1 .74c-33.12 23-60.9 35.57-69.8 26.1-8.23-8.77 3.39-32.5 25.05-61a101 101 0 01-6-8.87c-41.53 49-63.38 89.05-52.19 101 11.92 12.7 58-9.95 114.17-53.34l1.35-1.06c20.34-15.78 42-34.21 63.75-54.67S224 134.43 241.06 115l.84-.94c46.87-53.31 72.41-97.85 60.49-110.55z"
          fill="url(#planet-saturn_svg__e)"
        />
        <path
          d="M39.24 250.5c6.18 6.58 29.57-2.47 62.25-24.94l.91-.64c20.74-14.34 45.13-34 71.24-58.5 26.27-24.66 47.54-47.9 63.2-67.77l.4-.51c24.49-31.18 35-53.95 28.82-60.53-5.77-6.14-26.53 1.34-55.81 20.61 1.53 1.41 3 2.89 4.44 4.4 13.92-7.47 23.95-10 27.68-6 4 4.32 0 15.55-10 30.77l-.18.28c-13 19.71-35.95 46-64.3 72.63-28.17 26.43-55.69 47.54-76.14 59.33l-.68.4c-15.83 9-27.31 12.35-31.37 8-3.76-4-.54-14 8-27.62-1.4-1.52-2.77-3.07-4.08-4.68-21.3 28.27-30.17 48.6-24.38 54.77z"
          fill="url(#planet-saturn_svg__h)"
        />
      </g>
    </svg>
  );
}

export default SvgPlanetSaturn;
